import { reactive } from 'vue';
import { createGlobalState } from '@vueuse/core';

// FIXME: this composable conflates two unrelated concerns and is shared by
// every BCXPopup as a single global singleton. Two problems to untangle:
//
// 1. PDF-specific fields (pdfBase64, pdfFilename, setPdf) belong with
//    BCXPdfPopup, not with the generic popup. Base BCXPopup imports this
//    file purely for position/size — it should not see a `pdfBase64` ref.
//
// 2. The position/size/visibility state is a singleton, so opening two
//    BCXPopups at once means the second one clobbers the first's stored
//    geometry. Should be per-popup-instance, not global.
//
// Split into `usePopupPersistedGeometry` (per-instance) + `usePdfViewerState`
// (the PDF-specific bits) when touching this area again.
interface PopupState {
  isVisible: boolean;
  pdfBase64: string;
  pdfFilename: string;
  width: number | null;
  height: number | null;
  x: number | null;
  y: number | null;
  isFullscreen: boolean;
}

const usePopupState = createGlobalState(() => {
  const popupState = reactive<PopupState>({
    isVisible: false,
    pdfBase64: '',
    pdfFilename: '',
    width: null,
    height: null,
    x: null,
    y: null,
    isFullscreen: false,
  });

  const setPdf = (pdfBase64: string, pdfFilename: string) => {
    popupState.pdfBase64 = pdfBase64;
    popupState.pdfFilename = pdfFilename;
  };

  const hidePopup = () => {
    popupState.isVisible = false;
    popupState.pdfBase64 = '';
    popupState.pdfFilename = '';
  };

  const showPopup = async () => {
    if (popupState.isVisible) {
      popupState.pdfBase64 = '';
      popupState.pdfFilename = '';
    }

    popupState.isVisible = true;
    popupState.pdfBase64 = '';
    popupState.pdfFilename = '';
  };

  const storePositionAndSize = (width: number | null, height: number | null, x: number | null, y: number | null, isFullscreen: boolean) => {
    popupState.isFullscreen = isFullscreen;

    if (!isFullscreen) {
      popupState.width = width;
      popupState.height = height;
      popupState.x = x;
      popupState.y = y;
    }
  };

  return {
    popupState,
    showPopup,
    setPdf,
    storePositionAndSize,
    hidePopup,
  };
});

export default usePopupState;
